<template>
	<v-app>
		<NavBar />
		<v-main class="ma-4">
			<h1>Flights</h1>
			<v-dialog v-model="dialog">
				<template #activator="{ props }">
					<v-btn color="primary" class="ma-1" v-bind="props">
						New Flight
					</v-btn>
				</template>
				<v-card>
					<v-card-text>
						<FlightInput
							@closeOverlay="dialog = false"
							@updateTable="updateTable()"
						/>
					</v-card-text>
				</v-card>
			</v-dialog>
			<v-btn
				color="primary"
				class="ma-1"
				@click="$router.push('/flights/import')"
			>
				CSV Upload
			</v-btn>
			<v-btn
				color="primary"
				class="ma-1"
				@click="$router.push('/flights/export')"
			>
				Export Flights
			</v-btn>
			<FlightList ref="flightList" />
		</v-main>
	</v-app>
</template>

<script>
import NavBar from "@/components/NavBar";
import FlightInput from "@/components/FlightInput";
import FlightList from "@/components/FlightList.vue";
export default {
	data: () => ({
		dialog: false,
		componentKey: 0,
	}),
	components: {
		NavBar,
		FlightInput,
		FlightList,
	},
	methods: {
		updateTable() {
			this.$refs.flightList.updateTable();
		},
	},
};
</script>

<style></style>
